/* @flow */

import * as React from 'react';
import colorUtils from 'color';
import styled from '@emotion/styled';

import Icon from 'app/components/commons/Icon';

type Props = {
  disabled?: boolean,
  icon?: string,
  name: string,
  isOpen: boolean,
  onClick: () => void
};

const defaultProps = {
  disabled: false,
  icon: undefined
};

const StyledButton = styled.button(
  {
    flexBasis: '50%',
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    textTransform: 'uppercase',
    borderRight: '1px solid #333',
    outline: 'none'
  },
  ({ disabled, theme }) => ({
    backgroundColor: theme.color.basis1,
    color: theme.color.white,
    '&:disabled': disabled && {
      backgroundColor: colorUtils(theme.color.basis4)
        .alpha(0.5)
        .string(),
      color: colorUtils(theme.color.basis4)
        .alpha(0.5)
        .string()
    },
    '&:focus': {
      backgroundColor: theme.color.basis3
    }
  })
);

const Arrow = styled(Icon)(props => ({
  width: 10,
  height: 10,
  flexShrink: 0,
  transform: props.isOpen && 'rotate(-180deg)',
  transition: 'transform 0.3s ease-out',
  transformOrigin: 'center center',
  marginRight: 6
}));

const SportsIcon = styled(Icon)({
  fontSize: 28,
  marginRight: 10
});

const ContentDiv = styled.div({
  margin: 10,
  display: 'flex',
  alignItems: 'center'
});

function DropDownTab({ disabled, icon, name, isOpen, onClick }: Props) {
  return (
    <StyledButton disabled={disabled} onClick={onClick}>
      <ContentDiv>
        {icon && <SportsIcon type={`icon-sport-${icon}`} />}
        {disabled ? 'all' : name}
      </ContentDiv>
      <Arrow type="icon-chevron-down" isOpen={isOpen} />
    </StyledButton>
  );
}

DropDownTab.defaultProps = defaultProps;
export default DropDownTab;
